export default "__VITE_ASSET__xYB8M3OQ__"